import React, { useState } from "react";
const TextBox = ({ initialText }) => {
    const [expanded, setExpanded] = useState(false);
    const truncatedText = initialText.length > 112 ? initialText.slice(0, 112) + "..." : initialText;
    return (
        <div className="text-box">
            <span className="mr-2">{expanded ? initialText : truncatedText}.</span>
            {initialText.length > 112 && (
                <button className="w-max text-primary text-article font-medium hover:underline bg-transparent" onClick={() => setExpanded(!expanded)}>
                    {expanded ? "Show less" : "Show more"}
                </button>
            )}
        </div>
    );
};

export default TextBox;